var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInstaReels = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.227 1.5A5.727 5.727 0 0 0 1.5 7.227v9.546A5.727 5.727 0 0 0 7.227 22.5h9.546a5.727 5.727 0 0 0 5.727-5.727V7.227A5.727 5.727 0 0 0 16.773 1.5H7.227Zm9.546 1.718h-2.277l2.737 4.105h3.549v-.096a4.01 4.01 0 0 0-4.009-4.009Zm4.009 5.823H3.218v7.732a4.01 4.01 0 0 0 4.009 4.009h9.546a4.01 4.01 0 0 0 4.009-4.009V9.041ZM3.218 7.323h5.268l-2.587-3.88a4.012 4.012 0 0 0-2.681 3.784v.096Zm7.333 0h4.617l-2.737-4.105H7.814l2.737 4.105Z",
  fill: "url(#insta_reels_svg__a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.093 14.221a.521.521 0 0 1 0 .888l-5.212 3.106c-.331.197-.745-.05-.745-.444v-6.212c0-.395.414-.641.745-.444l5.212 3.106Z",
  fill: "url(#insta_reels_svg__a)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "insta_reels_svg__a",
  x1: 1.5,
  y1: 22.5,
  x2: 22.5,
  y2: 1.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FD5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#FF543E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C837AB"
})))));
export default SvgInstaReels;